import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** 無條件進位後格式化為整數字串（顯示用）*/
export function formatAmount(n: number): string {
  return Math.ceil(n).toLocaleString();
}
